import React from "react";
class PrivacyPolicyContent extends React.Component {
  render() {
    return (
      <section className="section " style={{ paddingTop: "40px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-left">
                <p>
                  <b>This Rental Agreement – Terms & Conditions</b> sets forth
                  the conditions on which we will provide the services offered
                  through the MightyWifi.net website ("the Website"). This
                  Rental Agreement - TERMS AND CONDITIONS' is a contract between
                  you and LTI Telecom LLC., having its registered office at 100
                  W. Forest Ave., Unit E, Englewood, New Jersey 07631, United
                  States of America, branded as MightyWifi ("Company"), and
                  covers all rentals made pursuant to this Website.
                  <br />
                  <br />
                  BEFORE YOU CLICK ON THE "ACCEPT" BUTTON, PLEASE CAREFULLY READ
                  THE TERMS AND CONDITIONS SET FORTH HEREUNDER. BY CLICKING ON
                  THE "I ACCEPT" BUTTON, YOU ARE BOUND BY AND HAVE BECOME A
                  PARTY TO THIS AGREEMENT. IF YOU DO NOT AGREE TO BE BOUND BY
                  THE TERMS AND CONDITIONS OF THIS AGREEMENT, THEN PLEASE DO NOT
                  CLICK "ACCEPT" OR CONTINUE TO USE THIS WEBSITE. WE RESERVE THE
                  RIGHT TO AMEND THIS RENTAL AGREEMENT AT ANY TIME. ANY SUCH
                  CHANGES WILL APPLY TO FUTURE RENTALS AFTER THE DATE ON WHICH
                  SUCH AMENDMENT GOES INTO EFFECT.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  1. Nature of Services
                </h3>
                <p>
                  Company provides a wireless device rental service (the
                  "hotspot"), along with user guides and accessories
                  (collectively the "Equipment") to travelers who plan to visit
                  the United States of America, Europe, or other international
                  destinations covered by Company. The MightyWifi uses the local cell tower network. The strength of signal and speed may vary depending on the location and network conditions in the area.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  2. Eligibility to Rent Equipment
                </h3>
                <p>
                  While our Equipment may be used by travelers of any age, we
                  can only rent to adults who are at least 18 years of age and
                  are fully able and competent to enter into the terms,
                  conditions, obligations, affirmations, representations, and
                  warranties set forth in this Rental Agreement, and to abide by
                  and comply with the terms set forth herein.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  3. Delivery
                </h3>
                <p>
                  When you place an order to rent the hotspot, we will ask you
                  to designate an address to which such Equipment will be
                  delivered and will also ask for your Rental Start Date and
                  Rental End Dates. The Equipment, along with an accompanying
                  user guide, will then be delivered to your designated address
                  before you arrive at your destination. It is your
                  responsibility to inspect all Equipment upon receipt and to
                  verify that it is in good working order and condition. If we
                  deliver the Equipment before your Designated Departure Date
                  and you fail to accept the delivery for any reason, then such
                  Equipment shall still be deemed accepted and you will still be
                  responsible for the return of the Equipment and for all
                  charges. It is your responsibility to ensure that you are
                  available to receive and that you accept the delivery of our
                  Equipment.{" "}
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  4. Use of Equipment
                </h3>
                <p>
                  You agree to exercise reasonable care in the use of all
                  Equipment, and to handle all Equipment in accordance with the
                  user guide. You further agree that you will not do any of the
                  following: (a) make repairs or modifications, or alter in any
                  way, the Equipment; (b) remove or alter any certification
                  markers affixed to the Equipment; (c) share the Equipment with
                  any third party, or allow any such third party to use the
                  Equipment, with the sole exception of a family member,
                  companion, or friend accompanying you on your trip; (d)
                  dispose of the Equipment; (e) grant any interest in the
                  Equipment to any third party; or (f) use the Equipment for any
                  illegal purpose.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  5-1. Rental Return
                </h3>
                <p>
                  All returns should be returned by a local mail service or
                  other generally recognized courier service in accordance with
                  our shipping instructions and postmarked no later than two (2)
                  days following your Rental End Date. The Equipment shall be
                  returned in good working order and condition. You assume all
                  risk of loss and damage from the return of all Equipment to
                  our designated address. We therefore recommend that you choose
                  "recorded deliveries" when possible. You agree to pay for all
                  return shipping charges at the time of the rental. You agree
                  to take responsibility and pay for all return shipping charges
                  upon the return of the Equipment for any country not mentioned
                  above.
                </p>

                <h3
                    className="font-weight-bold"
                    style={{
                      color: "#0076be",
                      fontSize: "1.3rem",
                      marginTop: "30px"
                    }}
                >
                  5-2. Device Purchase Return
                </h3>
                <p>
                  To return your purchased device, you must do so within 30 days of your order date. Item must be
                  returned with our original packaging with accessories that you received. Once we receive and review
                  the condition of the device, your refund will be processed within 10 days. There is 10% restocking
                  fee will be deducted from your refund payment. If the device is damaged by customer, we will not
                  accept your returns or refund your money.<br/><br/>
                  Customers are responsible for return shipping fees w/ tracking. We will not pay for postages for your
                  returns. To contact us about return instructions, please email us at <a href="mailto:support@mightywifi.net">support@mightywifi.net</a> with your
                  order #.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  6. Fees and Charges
                </h3>
                <p>
                  (a) Rental Charges. Rental fees for the use of our Equipment
                  are assessed commencing as of the Rental Start Date and ending
                  as of the postmarked date on which the Equipment is returned.
                  Our current rental fees are posted on our Website and may be
                  amended without prior notice. Please note that we do not apply
                  any credit for a partial billing date; all partial days will
                  be treated as full days for our billing purposes.
                  <br />
                  To place any order, we require a credit card to pre-pay all
                  charges. The credit card details will be kept on file until
                  the end of the Rental Period, if other charges need to be
                  placed.
                  <br />
                  (b) Service Charges. Usage charges must be pre-paid according
                  to the current airtime and data rate schedule posted to our
                  Website. You are liable for any charges relating to usage
                  outside of areas covered by MightyWifi's specified network,
                  and for charges related to usage outside regions for which the
                  purchased service was intended for.
                  <br />
                  (c) Late Return. All returns must be postmarked on or before
                  the second (2nd) day following your Rental End Date. If the
                  Equipment is received postmarked more than 2 days after the
                  Rental End Date, you will be incurring a daily penalty fee of
                  $9.95 per day the return is late. If MightyWifi does not
                  receive the Equipment within 15 working days of your rental
                  end date you will incur a final penalty fee for the loss of
                  the equipment. If for any reason you are unable to return the
                  Equipment to us, including but not limited to the Equipment
                  being lost or stolen during the Rental Period, then you should
                  contact us immediately, so that you do not incur additional
                  late charges. If the equipment is returned to us after we have
                  charged the loss penalty, we will immediately offset the
                  charge with the fee corresponding to the number of days your
                  device is considered overdue.
                  <br />
                  (d) Duty / Tax Charges. Deliveries or returns from other
                  countries (e.g. Europeans, Asians, etc.) might be subject to
                  Duty / Tax Charges. You are responsible for these charges.
                  <br />
                  (e) Loss, theft, or damage. Subject to Section 7 below, you
                  are solely responsible for all loss or damage to the Equipment
                  during the Rental Period. Any charges for damaged or lost
                  Equipment will be billed directly to the credit card used at
                  the time of purchase. Charges break down as follows: $125 per
                  MightyWifi device, $30 per MightyWifi battery, $15 per travel
                  adapter, $10 per pouch, $20 per power bank and $5 per car
                  charger. In the event that all Equipment is lost or damaged,
                  the total charge payable is $200. Without extra equipment
                  (power bank and car charger), the total charge is $175.
                  Damaged equipment is defined as equipment that is no longer
                  fit for re-use, including cosmetic damage that significantly
                  deteriorates the user experience (e.g. cracked screen).
                  <br />
                  Please note that we reserve the right to institute collection
                  procedures against you if you fail to return our Equipment to
                  us as required by this Rental Agreement or fail to pay any
                  service charges, damage charges, or late fees that you incur.
                  If it becomes necessary for us to institute collection
                  procedures against you, you agree to pay the costs of
                  collection, including without limitation reasonable attorneys'
                  fees. Any late fees that we collect will not waive any other
                  right or remedy that may otherwise be available to you under
                  this Agreement.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  7. Insurance
                </h3>
                <p>
                  Insurance is available for purchase at an additional charge,
                  which provides coverage for any damage, loss (including theft)
                  of all Equipment, after a $50 deductible (note that the
                  deductible is on top of the insurance cost).
                  <br />
                  In simple terms, if you purchase insurance, your maximum
                  liability (i.e. the maximum you would be charged) for any
                  damage, loss or theft is $50.
                  <br />
                  Without insurance, you would be charged the full replacement
                  cost as follows: $150 per MightyWifi device, $15 per travel
                  adapter, $10 per pouch, $20 per power bank and $5 per car
                  charger. If all Equipment is lost or damaged, the total charge
                  payable is $200. Without extra equipment (power bank and car
                  charger), the total charge is $175. Damaged equipment is
                  defined as equipment that is no longer fit for reuse,
                  including cosmetic damage that significantly deteriorates the
                  user experience (e.g. cracked screen).
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  8. Cancellation
                </h3>
                <p>
                  You can cancel your rental anytime you want. There is no
                  cancellation fee. Please contact us to confirm your
                  cancellation. If your device has already been dispatched, then
                  we will not be able to refund relevant shipping charges. We
                  also cannot refund days with usage on the device. If you
                  already have the device, you will need to return it to us
                  immediately.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  9. Ownership of Equipment
                </h3>
                <p>
                  By using this service, you agree and acknowledge that you will
                  acquire no rights in the Equipment. You agree that we will
                  retain all ownership of the Equipment, including but not
                  limited to user guides and accessories.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  10. Customer Warranty
                </h3>
                <p>
                  If you are renting this Equipment on behalf of an entity
                  rather than for your own personal use, then you represent and
                  warrant that you are fully authorized to enter into this
                  Agreement on behalf of such entity, and to bind such entity to
                  the terms and conditions set forth in this Rental Agreement.
                  You further represent and warrant that you are not committing
                  any fraud or misrepresentation in entering this Rental
                  Agreement.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  11. Company Warranty
                </h3>
                <p>
                  Company warrants that the Equipment will be delivered in good
                  working order and condition, and that it will continue to
                  operate properly during the term of the Rental Period.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  12. Remedies
                </h3>
                <p>
                  In the event of any failure to meet the Company Warranty set
                  forth above, our sole liability and your sole and exclusive
                  remedy will be to repair or replace the Equipment at our
                  expense. If we replace the Equipment, you will receive the
                  same or reasonably similar Equipment to use for the remainder
                  of the Rental Period. It is your obligation to notify us
                  immediately if you experience any problems with your
                  Equipment.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  13. Disclaimer of Warranties
                </h3>
                <p>
                  EXCEPT FOR THE WARRANTY SET FORTH IN SECTION 11 ABOVE, COMPANY
                  MAKES NO REPRESENTATIONS, WARRANTIES, CONDITIONS, OR
                  GUARANTEES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE,
                  ORAL OR WRITTEN, REGARDING THE EQUIPMENT OR THIS RENTAL
                  AGREEMENT. WE MAKE NO ENDORSEMENTS REGARDING ANY THIRD PARTY
                  LISTED IN OUR USER GUIDE AND CANNOT WARRANT OR MAKE ANY
                  REPRESENTATION ABOUT THE QUALITY OF THEIR SERVICES. WE CANNOT
                  WARRANT OUR EQUIPMENT WILL OPERATE UNINTERRUPTED OR
                  ERROR-FREE, THAT IT WILL OPERATE PROPERLY ON ALL WIRELESS
                  NETWORKS, THAT IT WILL MEET ALL OF YOUR NEEDS, OR THAT ANY
                  THIRD-PARTY SERVICES THAT YOU ACCESS THROUGH THE USER GUIDE
                  WILL BE UNINTERRUPTED, ERROR-FREE, OR MEET YOUR NEEDS. WE
                  CANNOT BE RESPONSIBLE FOR THE LEGALITY, ADEQUACY, ACCURACY,
                  QUALITY, OR OPERATION OF ANY THIRD-PARTY SERVICES. COMPANY
                  EXPRESSLY DISCLAIMS ALL OTHER WARRANTIES WITH RESPECT TO THE
                  EQUIPMENT, OUR RENTAL SERVICES, AND ANY THIRD-PARTY SERVICES
                  ACCESSED THROUGH OUR USER GUIDE, WHETHER EXPRESS OR IMPLIED,
                  INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF
                  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
                  NON-INFRINGEMENT OF THIRD-PARTY RIGHTS. YOU ASSUME SOLE AND
                  EXCLUSIVE RESPONSIBILITY FOR THE USE OF THE EQUIPMENT AND FOR
                  ANY RELIANCE ON ANY THIRD-PARTY SERVICES. While we will make
                  every effort to erase all personal information left on the
                  returned Equipment, we cannot be responsible for ensuring the
                  protection of personal information left on returned Equipment.
                  YOU ASSUME THE SOLE RISK AND RESPONSIBILITY of ERASING
                  PERSONAL INFORMATION PRIOR TO RETURNING EQUIPMENT RENTED
                  PURSUANT TO THIS RENTAL AGREEMENT.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  14. Consequential Damages; Limitation of Liability
                </h3>
                <p>
                  TO THE EXTENT PERMITTED BY LAW, NEITHER COMPANY NOR ITS
                  OFFICERS, DIRECTORS, EMPLOYEES, CONTRACTORS, AGENTS, AND
                  REPRESENTATIVES SHALL IN ANY EVENT BE LIABLE TO YOU FOR ANY
                  CONSEQUENTIAL, PUNITIVE, EXEMPLARY, SPECIAL, INCIDENTAL, OR
                  INDIRECT DAMAGES OF ANY KIND, INCLUDING WITHOUT LIMITATION,
                  LOSS OF DATA OR PROFITS, LOSS OF GOODWILL OR BUSINESS
                  REPUTATION, COST OF PROCUREMENT OR REPLACEMENT GOODS AND
                  SERVICES, COVER, OR RELIANCE DAMAGES, OR ANY OTHER TANGIBLE
                  LOSS IN CONNECTION WITH THIS AGREEMENT, WHETHER SUCH LIABILITY
                  ARISES FROM ANY CLAIM BASED ON CONTRACT, WARRANTY, TORT
                  (INCLUDING NEGLIGENCE), STRICT LIABILITY, INFRINGEMENT OF
                  INTELLECTUAL PROPERTY, OR OTHERWISE, AND WHETHER OR NOT WE
                  HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
                  WE AGREE THAT THESE LIMITATIONS WILL SURVIVE AND APPLY EVEN IF
                  ANY LIMITED REMEDY SPECIFIED IN THIS AGREEMENT IS FOUND TO
                  HAVE FAILED ITS ESSENTIAL PURPOSE. Our total aggregate
                  liability to you from all causes of action and under all
                  theories of liability will be limited to and will not exceed
                  the total amount of all fees paid by you under this Rental
                  Agreement. This limitation will apply notwithstanding the
                  failure of the essential purpose of any remedy hereunder.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  15. Indemnification
                </h3>
                <p>
                  By agreeing to this Rental Agreement, you agree to indemnify,
                  defend, and hold harmless Company, our officers, directors,
                  employees, independent contractors, representatives, agents,
                  and other customers against any and all claims, demands,
                  losses, costs, or expense, including but not limited to
                  reasonable attorney's fees, in any way connected with (a) a
                  breach of the terms and conditions of this Rental Agreement;
                  and (b) any dispute between you and any third party service,
                  which you engaged through our user guide.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  16. Miscellaneous
                </h3>
                <p>
                  We reserve the right to discontinue our rental services or
                  terminate and/or amend this Rental Agreement at any time at
                  our sole discretion. Expiration or termination of this Rental
                  Agreement will not relieve you of any payment obligations
                  hereunder. Sections 2-6, 12-15 shall survive any such
                  expiration or termination. You may not assign or transfer any
                  of your rights or obligations under this Rental Agreement
                  without our prior written consent. You agree that we may
                  assign this Rental Agreement without prior notice in the event
                  of a merger, acquisition, or sale of all or part of our
                  business. No waiver of any breach of the terms of this Rental
                  Agreement, no matter how long continuing or how often
                  repeated, shall be deemed a waiver of any subsequent breach
                  thereof, nor shall any delay or omission to exercise any
                  right, power, or privilege hereunder be deemed a waiver of
                  such right, power, or privilege. If any provision of this
                  Rental Agreement is held unenforceable or in conflict with the
                  law of any jurisdiction, the validity of the remaining
                  provisions shall not be affected by such holding. The meaning
                  of that provision will be construed to the extent feasible, to
                  render the provision enforceable. If no feasible
                  interpretation will save such provision, it is to be severed
                  from the remainder of the terms of this Rental Agreement,
                  which are to remain in full force and effect. This Agreement
                  contains the entire understanding of the Parties with respect
                  to the subject matter contained herein, and shall supersede
                  all prior agreements and understandings, whether written or
                  oral.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  17. Private Data
                </h3>
                <p>
                  Private data in the form of usage (data consumption) cannot be
                  recovered by MightyWifi for a period more than one (1) week,
                  and requests for such must be made at most one (1) week after
                  the rental end date – requests later than this will not be
                  processed. Any requests for a period of longer than one (1)
                  week are up to the sole discretion of MightyWifi to
                  accommodate or not, and MightyWifi reserves the right to levy
                  a fee to cover the expense of such applications. These
                  restrictions are the result of this form of private data not
                  being held by MightyWifi. Rather, it is logged by the relevant
                  mobile network operator used during the rental period. By
                  purchasing service offered by Company, you agree to receive
                  promotional messages relating to similar products and services
                  we offer.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  18. Discount vouchers
                </h3>
                <p>
                  Discount vouchers must be used at the time of purchase and
                  cannot be exchanged for credit on previous purchases. The
                  discount is applied to rental fees only, not extras such as
                  insurance or car chargers. To use, put the voucher in the
                  indicated text field in the third page of the checkout process
                  ("Got a coupon?"), and hit "Apply discount". The discount will
                  be visible immediately in the order summary box.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  19. Force majeure
                </h3>
                <p>
                  In the event we fail to perform any obligation pursuant to
                  this Agreement due to an "act of God," or an act of any
                  government, terrorism, riot, war, accident, or any deficiency
                  in materials or transportation or any other cause of any
                  nature beyond our control, such failure shall not be deemed to
                  be a breach of this Agreement, provided that we notify you of
                  the existence and nature of the reason for our nonperformance
                  and delay, and we resume performance immediately upon the
                  conclusion of the relevant force majeure.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  20. Governing Law - Dispute Resolution
                </h3>
                <p>
                  This Rental Agreement is governed by the laws of the State of
                  New Jersey, United States of America, without regard to
                  conflicts of law principles. All disputes arising under this
                  Rental Agreement shall be submitted to binding arbitration in
                  New Jersey, USA, under the Rules of Arbitration for the
                  International Chamber of Commerce by one arbitrator mutually
                  agreed upon by you and Company in accordance with the
                  aforementioned Rules. Costs of the arbitration, including
                  administrative and arbitrator's fees, shall be shared equally
                  by you and Company. The arbitration award shall be final, and
                  each party shall comply in good faith to the entry of the
                  arbitrator's award in any court having jurisdiction. If
                  judicial enforcement or review of the arbitrator's decision is
                  sought, the prevailing party shall be entitled to costs and
                  reasonable attorneys' fees. For the avoidance of doubt, all
                  claims you bring against Company must be resolved in
                  accordance with this Section 15. All claims filed or brought
                  against Company contrary to this Section 15 shall be
                  considered improperly filed. Should you file a claim contrary
                  to this Section 15, you agree the Company may recover
                  attorneys' fees and costs of up to $3,000 if Company has
                  notified you in writing of the improperly filed claim and you
                  have failed to properly withdraw the claim.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  21. Rental period
                </h3>
                <p>
                  The Rental Period commences on your rental start date ("Rental
                  Start Date") and expires upon your designated rental end date
                  ("Rental End Date").
                </p>

                <h3
                    className="font-weight-bold"
                    style={{
                      color: "#0076be",
                      fontSize: "1.3rem",
                      marginTop: "30px"
                    }}
                >
                  22. Warranty
                </h3>
                <p>
                  We are happy to exchange or repair any defective units that you have encountered or parts within
                  one-year of your purchase date. Please contact us at <a href="mailto:support@mightywifi.net">support@mightywifi.net</a> with your issues and
                  concerns.
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PrivacyPolicyContent;



// WEBPACK FOOTER //
// ./src/pages/termAndConditions/TermsContent.js